import React from 'react';
import { MgpGaugeChart } from '../components/MgpGaugeChart/MgpGaugeChart';
import { ResultsHeading, ResultsText, ResultsWrapper } from './GoalsStyles';

export const GoalsEmpty = () => {
  return (
    <>
      <MgpGaugeChart />
      <ResultsWrapper>
        <ResultsHeading>Results</ResultsHeading>
        <ResultsText>There is no information to display</ResultsText>
      </ResultsWrapper>
    </>
  );
};
